import { ShieldCheck, Truck, Wrench, Factory } from "lucide-react";

const PILLARS = [
  { i: ShieldCheck, t: "Qualidade Garantida", d: "Produtos de marcas líderes." },
  { i: Truck, t: "Entrega Nacional", d: "Frota própria e despachos para todo o país." },
  { i: Wrench, t: "Suporte Técnico", d: "Equipa especializada." },
  { i: Factory, t: "Stock Industrial", d: "Disponibilidade imediata." },
];

export default function HomeAbout() {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="home-about">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-8 md:gap-14 items-start">
        <div className="col-span-12 md:col-span-5">
          <div className="overline mb-4">Sobre a CETIBER</div>
          <h2 className="font-display font-bold uppercase text-4xl md:text-5xl text-[#0d4c7d] leading-[0.95] tracking-tight">
            Especialistas que<br />fixam o que importa.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-7 md:pt-4">
          <p className="text-lg leading-relaxed text-[#333]">
            A CETIBER é especialista na comercialização de sistemas de fixação e
            acessórios industriais, oferecendo soluções completas para diversos setores.
          </p>
          <div className="grid grid-cols-2 gap-5 mt-10">
            {PILLARS.map(({ i: Icon, t, d }) => (
              <div key={t} className="p-5 border border-[#e4e4e7] border-l-4 border-l-[#1FA8E0] bg-[#f9fafb]">
                <Icon size={24} className="text-[#0d4c7d] mb-3" />
                <div className="font-display font-bold uppercase text-lg tracking-wide text-[#222]">{t}</div>
                <div className="text-sm text-[#555] mt-1">{d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
